export default function log () {
  // without this arguments are not displayed on the logcat logs
  console.log(object_values(arguments).join(" "))
}

function object_values(obj) {
  var res = []
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      res.push(obj[i])
    }
  }
  return res
}